import { type RxCollection, type RxCollectionCreator } from 'rxdb';
import { AppointmentProposalOptionModifier } from '../../../data-access/appointmentProposalOptionModifiers';
import {
  identityMigration,
  lwwConflictHandler,
} from '../../rxdb/utils/collectionDefaults';

const modifiersSchema = {
  version: 3,
  primaryKey: 'appointmentProposalOptionModifierId',
  type: 'object',
  properties: {
    appointmentProposalOptionModifierId: { type: 'string', maxLength: 36 },
    appointmentProposalOptionId: { type: 'string', maxLength: 36 },
    appointmentProposalId: { type: 'string', maxLength: 36 },
    appointmentId: { type: 'string', maxLength: 36 },
    jobId: { type: 'string' },
    entityType: { type: 'string' },
    discountsAndFeesId: { type: 'string' },
    modifierType: { type: 'string' },
    displayName: { type: 'string' },
    description: { type: 'string' },
    amountType: { type: 'string' },
    amount: { type: 'number' },
    limit: { type: 'number' },
    taxable: { type: 'boolean' },
    status: { type: 'string' },
    sortOrder: { type: 'number' },
    categoryIds: { type: 'array' },
    qualifyingPricebookCategoryIds: { type: 'array' },
    qualifyingPricebookIds: { type: 'array' },
    images: { type: 'array' },
    externalIds: { type: 'array' },
    roundingRule: { type: 'object' },
    taxBasis: { type: 'string' },
    errorDetail: { type: ['object', 'null'] },
    syncedAt: {
      type: 'number',
      multipleOf: 1,
      maximum: 9999999999999,
      minimum: 0,
    },
    updatedAt: { type: 'string' },
    createdAt: { type: 'string' },
    offlineSyncErrors: { type: ['object', 'null'] },
  },
  indexes: [
    ['appointmentProposalOptionId'],
    ['appointmentProposalId'],
    ['syncedAt'],
  ],
  required: [
    'appointmentProposalOptionModifierId',
    'appointmentProposalOptionId',
    'appointmentProposalId',
    'syncedAt',
  ],
} as const;

export const modifiersCollections: Record<
  'appointment_proposal_option_modifiers',
  RxCollectionCreator
> = {
  appointment_proposal_option_modifiers: {
    autoMigrate: false,
    schema: modifiersSchema,
    conflictHandler: lwwConflictHandler,
    migrationStrategies: {
      1: identityMigration,
      2: identityMigration,
      3: identityMigration,
    },
  },
};

export type AppointmentProposalOptionModifierDocType =
  AppointmentProposalOptionModifier & {
    syncedAt: number;
  };

export type AppointmentProposalOptionModifiersCollections = {
  appointment_proposal_option_modifiers: RxCollection<AppointmentProposalOptionModifierDocType>;
};
